export default __webpack_public_path__ + "static/media/Imagen_grupos.5e9c557b.png";